import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';

import { RideCombobox } from '@rimac-seguros/ride-system-components';

import { ModalWithSearch } from '../ModalWithSearch';
import { useHideRideMenu } from '@/hooks/useHideRideMenu';
import helpers from '@/utils/helpers';

import './styles.scss';

export const CustomDropdown = ({
  isShowModal,
  list = [],
  name,
  label,
  titleModal,
  iconResult,
  hasSearch,
  loading,
  disabled,
  register,
  setValue,
  watch,
  mappingTagActions,
  onSelect,
  placeholder,
  virtualized,
  error,
  errorMessage,
  customClass,
  isEmbedded,
  smallText,
  isCustomDropdown = true
}) => {
  const isVE = helpers.validateVidaEndosable();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const currentInputValue = useRef('');
  const currentInputTimer = useRef(null);
  const { ref: registerRef, ...restRegister } = register(name, { required: errorMessage ?? true });
  const hideRideMenuCondition = useCallback(() => isVE && isShowModal && isCustomDropdown, [
    isVE,
    isShowModal,
    isCustomDropdown
  ]);
  useHideRideMenu(hideRideMenuCondition);

  const handleSelect = (value) => {
    setValue(name, value, { shouldValidate: true });
    onSelect?.(value);
  };

  const getFilteredList = useMemo(
    () =>
      list.filter((option) =>
        option.label.toLowerCase().includes(search.toLowerCase())
      ),
    [list, search]
  );

  const handleRef = (el) => {
    if (isVE && isShowModal && el) {
      el.parentElement.getElementsByTagName('input')[0].readOnly = true
    }
    registerRef(el);
  }

  useEffect(() => {
    if (isEmbedded) {
      helpers.sendMessageToApp(open ? "EMBEDDED-APP-HIDE-TOPBAR" : "EMBEDDED-APP-SHOW-TOPBAR");
    }
  }, [isEmbedded, open])

  return (
    <div
      className={`custom-dropdown flex relative w-full ${customClass || ""}`}
      onClick={() => isShowModal && !disabled && setOpen(true)}
    >
      {isShowModal && <div className={`custom-dropdown_mask ${isVE ? 'is-ve' : ''}`} />}
      <RideCombobox
        {...restRegister}
        ref={handleRef}
        data-menu-testid='custom-dropdown'
        label={label}
        aria-required
        size="large"
        options={getFilteredList}
        value={watch(name)}
        loading={loading}
        disabled={disabled}
        className={!isVE && isShowModal ? 'remove-icon-x-dropdown' : ''}
        onSelect={(e) => {
          const value = e.value ? String(e.value) : '';
          if (value) {
            mappingTagActions && mappingTagActions(label, `${e.label}`);
          }
          handleSelect(value);
        }}
        onFilter={(option, inputValue) => {
          const hasChanged = currentInputValue.current !== inputValue;
          clearTimeout(currentInputTimer.current);
          currentInputTimer.current = setTimeout(() => {
            currentInputValue.current = inputValue;
          }, 500);
          const status = option.label.toLowerCase().includes(inputValue?.toLowerCase())
          return hasChanged ? status : true;
        }}
        error={error}
        errorMessage={errorMessage}
        onOpenChange={(e) => 
          !e && setSearch('')
        }
      />

      {isShowModal && open && (
        <ModalWithSearch
          title={titleModal}
          name={name}
          iconResult={iconResult}
          isOpen={open}
          hasSearch={!!hasSearch}
          options={list}
          defaultValue={watch(name)}
          onConfirm={handleSelect}
          onClose={() => setOpen(false)}
          placeholder={placeholder}
          virtualized={virtualized}
          smallText={smallText}
        />
      )}
    </div>
  );
};
